import styled from "styled-components";

import { FrownOutlined } from '@ant-design/icons';

export const StyledModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  z-index: 9999;
  
  width: 450px; 
  max-width: 90%;
  max-height: 800px; 
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  overflow-y: auto; 

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const ModalHeader = styled.h1`
  font-size: 22px;
  color: #262626;
  margin-top: -30px;
  font-weight: 600;
`;

export const ModalContent = styled.p`
  font-size: 14px;
`;

export const ModalLink = styled.a`
  background-color: transparent;
  color: #0074b5;
  padding: 0;
  margin: 0;
`;

export const ModalButton = styled.button`
  background-color: green;
  color: white; 
  padding: 10px 20px;
  font-size: 16px; 
  border: none; 
  outline: none;
  cursor: pointer;
`;

export const StyledModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 20px;
`;

export const SadFaceIcon = styled(FrownOutlined)`
  font-size: 70px;
  color: #518ccb;
  margin-bottom: 20px;
`;